import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import BrandMark from "../../components/BrandMark";
import { Card, CardContent } from "../../components/ui/card";
import { CheckCircle2, ShieldAlert } from "lucide-react";
import { API } from "../../lib/api";

export default function PublicVerify() {
  const { proof } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    axios.get(`${API}/verify/${proof}`)
      .then(r => setData(r.data))
      .catch(() => setErr("Proof hash not found in ledger."));
  }, [proof]);

  return (
    <div className="min-h-screen bg-erf-cream text-erf-dark" data-testid="public-verify-page">
      <header className="bg-erf-dark text-erf-cream px-6 py-5 flex items-center justify-between">
        <div className="flex items-center gap-3"><BrandMark size={48} /><div>
          <div className="font-display font-bold">ERF ENTERPRISES LLC</div>
          <div className="text-[11px] font-mono uppercase tracking-widest text-erf-cream/50">Signature Verification</div>
        </div></div>
        <Link to="/" className="mono text-[11px] uppercase tracking-widest text-erf-cream/60 hover:text-erf-cream">Home</Link>
      </header>
      <main className="max-w-xl mx-auto p-6">
        {err && (
          <Card className="border-red-300 bg-red-50" data-testid="public-verify-error">
            <CardContent className="p-6 flex items-center gap-2 text-red-900">
              <ShieldAlert className="w-5 h-5" /> {err}
            </CardContent>
          </Card>
        )}
        {data && (
          <Card className="border-emerald-300 bg-emerald-50" data-testid="public-verify-ok">
            <CardContent className="p-6 space-y-3">
              <div className="flex items-center gap-2 text-emerald-900 font-display font-semibold text-lg">
                <CheckCircle2 className="w-5 h-5" />
                Signed on {(data.signed_on || "").slice(0, 19).replace("T"," ")} using {data.provider || "internal_placeholder"}
              </div>
              {data.contract && (
                <div className="text-sm font-nav">
                  Contract <span className="mono">{data.contract.id.slice(0,8)}</span> · version {data.contract.version} ·
                  status <strong>{data.contract.status}</strong> · {data.contract.signer_count} signer(s)
                </div>
              )}
              <div className="mono text-[10px] text-emerald-900/70 break-all">Proof hash: {data.proof_hash}</div>
              <div className="mono text-[10px] text-emerald-900/70 break-all">Prev hash: {data.prev_hash}</div>
              <div className="mono text-[10px] text-emerald-900/70">Audit ledger index: #{data.hash_chain_index}</div>
              <div className="text-[11px] font-mono uppercase tracking-widest text-emerald-900/50 pt-3 border-t border-emerald-200">
                Internal placeholder e-signature. Not a substitute for a certified e-signature provider.
              </div>
            </CardContent>
          </Card>
        )}
      </main>
    </div>
  );
}
